import {Component, Input, OnInit} from '@angular/core';
import {ImageDefinition} from '../../../../models/image-model';

@Component({
  selector: 'app-offers-progress-dialog-logo',
  templateUrl: './offers-progress-dialog-logo.component.html'
})
export class OffersProgressDialogLogoComponent implements OnInit {

  @Input() logo: ImageDefinition;
  @Input() correctOffersAmount: number;

  constructor() { }

  ngOnInit() {
  }

}
